import T from '@/components/Helpers/Translate'
import LoginForm from '@/components/_forms/LoginForm'
import { Button } from '@/components/_ui/Button'
import { Drawer, DrawerContent, DrawerTrigger } from '@/components/_ui/Drawer'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/_ui/Popover'
import useParseLinkUrlWithLocale from '@/lib/hooks/routing/useParseLinkUrlWithLocale'
import Image from 'next/image'
import useGlobalStore from '@/store/useGlobalStore'

import React from 'react'

const LoginPopover = ({ isMobile }: { isMobile?: boolean }) => {
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()

  const {
    app: { isLoginPopoverOpen },
    setLoginPopoverOpen,
  } = useGlobalStore()

  const accountButton = () => (
    <Button
      className="pointer-events-auto"
      size="icon"
      variant="icon"
      data-test={`login-popover-button${isMobile ? '-mobile' : ''}`}
    >
      <Image src="/icons/account.svg" alt="Account" height={25} width={25} />
    </Button>
  )

  const dontHaveAnAccountSection = () => (
    <div className="mt-5 flex w-full flex-col items-center border-t-2 p-5 text-primary">
      <p>
        <T>dont_have_account</T>
      </p>
      <a
        className="text-primary underline"
        href={parseLinkUrlWithLocale({
          url: '/account/signup',
          withQueryString: true,
        })}
      >
        <T>signup</T>
      </a>
    </div>
  )

  if (isMobile) {
    return (
      <Drawer open={isLoginPopoverOpen} onOpenChange={setLoginPopoverOpen}>
        <DrawerTrigger>{accountButton()}</DrawerTrigger>
        <DrawerContent className="p-8">
          <h1 className="mt-5 text-[32px] text-primary">
            <T>login</T>
          </h1>
          <LoginForm
            onLoginSuccess={() => {
              setLoginPopoverOpen(false)
            }}
          />
          {dontHaveAnAccountSection()}
        </DrawerContent>
      </Drawer>
    )
  }

  return (
    <Popover open={isLoginPopoverOpen} onOpenChange={setLoginPopoverOpen}>
      <PopoverTrigger tabIndex={-1}>{accountButton()}</PopoverTrigger>
      <PopoverContent className="mr-10 w-[350px] p-5">
        <h1 className="mt-5 text-[32px] text-primary">
          <T>login</T>
        </h1>
        <LoginForm
          onLoginSuccess={() => {
            setLoginPopoverOpen(false)
          }}
          page="account_pop_up"
        />
        {dontHaveAnAccountSection()}
      </PopoverContent>
    </Popover>
  )
}

export default LoginPopover
